import React, { useState, useEffect } from "react";
import SaleContext from "./SaleContext";

const API =
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:4000";

export default function SaleProvider({ children }) {
  const [sale, setSale] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSale();
  }, []);

  const loadSale = async () => {
    try {
      const res = await fetch(
        `${API}/api/sitewide-sales/active`
      );

      const data = await res.json();

      setSale(data);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <SaleContext.Provider
      value={{
        sale,
        loading,
        refreshSale: loadSale,
      }}
    >
      {children}
    </SaleContext.Provider>
  );
}
